(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const selector = [
    '.mh-button', '.gk-atc', '.gk-sticky button',
    '.header nav a', '.header-actions a', '.header-actions button',
    '.curler-variant', '.curler-bundle', '.gk-bundle',
    '.mh-why__grid article', '.mh-trust__grid article',
    '.gk-thumb', 'cart-drawer button', 'cart-drawer a.button'
  ].join(',');

  const release = element => {
    if (!element) return;
    element.classList.remove('is-liquid-pressed');
    element.classList.add('is-liquid-releasing');
    window.setTimeout(() => element.classList.remove('is-liquid-releasing'), 420);
  };

  document.addEventListener('pointerdown', event => {
    const element = event.target.closest(selector);
    if (!element || element.matches(':disabled,[aria-disabled="true"]')) return;
    const rect = element.getBoundingClientRect();
    element.style.setProperty('--liquid-x', `${event.clientX - rect.left}px`);
    element.style.setProperty('--liquid-y', `${event.clientY - rect.top}px`);
    element.classList.remove('is-liquid-releasing');
    element.classList.add('is-liquid-pressed');
  }, { passive: true });

  ['pointerup', 'pointercancel'].forEach(type => document.addEventListener(type, event => {
    release(event.target.closest(selector) || document.querySelector(`${selector.split(',').map(item => `${item.trim()}.is-liquid-pressed`).join(',')}`));
  }, { passive: true }));

  window.addEventListener('blur', () => document.querySelectorAll('.is-liquid-pressed').forEach(release));
})();
